import React from "react";
import TownhouseShowroom from "../Property/townhouse_showroom";
import BayshopWarehouse from "../Property/bayshop_warehouse";
import Soho from "../Property/soho";
import Multiplex from "../Property/multiplex";
import Foodcourt from "../Property/foodcourt";
import Retail from "../Property/retail";
import Sco from "../Property/sco";
import Booth from "../Property/booth";
import OfficeSpace from "../Property/officeSpace";

const PropertyCategoryHandler = ({ onChange, category, propertyData }) => {
  const categoryName = category?.toLowerCase();
  const normalizedCategory = categoryName?.replace(/\s+/g, "")?.toLowerCase();

  // console.log("Category Name In Property Category Handler", normalizedCategory);

  const categorySwitchHandler = () => {
    if (normalizedCategory === "apartment") return;
    const forEdit = Boolean(propertyData?._id);

    switch (normalizedCategory) {
      case "townhouse": {
        return (
          <TownhouseShowroom
            propertyDataBackend={forEdit ? propertyData : null}
            onChange={onChange}
          ></TownhouseShowroom>
        );
      }
      case "showroom": {
        return (
          <TownhouseShowroom
            propertyDataBackend={forEdit ? propertyData : null}
            onChange={onChange}
          ></TownhouseShowroom>
        );
      }
      case "bayshop": {
        return (
          <BayshopWarehouse
            propertyDataBackend={forEdit ? propertyData : null}
            onChange={onChange}
          ></BayshopWarehouse>
        );
      }
      case "warehouse": {
        return (
          <BayshopWarehouse
            propertyDataBackend={forEdit ? propertyData : null}
            onChange={onChange}
          ></BayshopWarehouse>
        );
      }
      case "soho": {
        return (
          <Soho
            propertyDataBackend={forEdit ? propertyData : null}
            onChange={onChange}
          ></Soho>
        );
      }
      case "multiplex": {
        return (
          <Multiplex
            propertyDataBackend={forEdit ? propertyData : null}
            onChange={onChange}
          ></Multiplex>
        );
      }
      case "foodcourt": {
        return (
          <Foodcourt
            propertyDataBackend={forEdit ? propertyData : null}
            onChange={onChange}
          ></Foodcourt>
        );
      }
      case "retailshops": {
        return (
          <Retail
            propertyDataBackend={forEdit ? propertyData : null}
            onChange={onChange}
          ></Retail>
        );
      }
      case "sco": {
        return (
          <Sco
            propertyDataBackend={forEdit ? propertyData : null}
            onChange={onChange}
          ></Sco>
        );
      }
      case "booth": {
        return (
          <Booth
            propertyDataBackend={forEdit ? propertyData : null}
            onChange={onChange}
          ></Booth>
        );
      }
      case "skydeck": {
        return (
          <Booth
            propertyDataBackend={forEdit ? propertyData : null}
            onChange={onChange}
          ></Booth>
        );
      }
      case "officespace": {
        return (
          <OfficeSpace
            propertyDataBackend={forEdit ? propertyData : null}
            onChange={onChange}
          ></OfficeSpace>
        );
      }
      default:
        return null;
    }
  };

  return <div>{categorySwitchHandler()}</div>;
};

export default PropertyCategoryHandler;
